import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import ServiceArea from "@/components/ServiceArea";
import Testimonials from "@/components/Testimonials";
import QuoteForm from "@/components/QuoteForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { useSettings } from "@/context/SettingsContext";

export default function HomePage() {
  const { loading } = useSettings();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-yellow-400 font-display font-medium">Loading…</div>
      </div>
    );
  }
  return (
    <div data-testid="home-page" className="bg-[#050505] min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <ServiceArea />
        <Testimonials />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
